import { gql } from 'apollo-boost';
import { ContentType, Field } from '../Common/types/CatalogTypes';
import { capitalize } from '../Common/utils';

export const getFilterOptionsQueryName = (contentType: ContentType) => {
    return `many${capitalize(contentType.slug)}`;
};

export const filterOptionsQuery = (
    contentType: ContentType,
    field: Field,
) => gql`{
        ${getFilterOptionsQueryName(contentType)} (take: 100, skip: 0) {
            results {
                ${field.slug}
            }
        }
}`;
